// eslint-disable-next-line import/prefer-default-export
export const TEXT_MODAL_TITLE = [
  '¡Tu solicitud ha sido aceptada!',
  'Tus ahorros vienen en camino',
  '¡Llegaron tus ahorros!',
];

export const TEXT_MODAL_STEPS = [
  ['Tu solicitud ha sido aceptada, lo que significa que autorizas el traspaso de tus saldos desde tu AFP actual hacia Cuprum AFP.'],
  ['Dentro de los próximos días, tu antigua AFP traspasará tus ahorros. Pronto podrás crear tu clave e ingresar a la app y al sitio web de Cuprum AFP.'],
  ['El traspaso de tus fondos fue un éxito.', 'Desde hoy ya puedes acceder a todos nuestros servicios digitales a través de nuestra app o sitio web de Cuprum AFP.'],
];
